import { StoreSchema } from '../../types/store'

export  const selectIsAuthenticated = (store: StoreSchema) => store.auth
